import React, { useState, useEffect } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//components
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";

//assets
import TEXT from "../../../utils/text/surveys_national.json";

//utils - functions
import { getCsvData } from "../../../utils/functions/getCsvData";

export default function Mexico({ survey }) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data
  const [data, setData] = useState([]);

  //useState - questions
  const [questions, setQuestions] = useState([]);

  //useEffect
  useEffect(() => {
    if (survey !== "") handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [survey]);

  //handle get data
  const handleGetData = async () => {
    const csv1 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q1.csv`
    );
    const csv2 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q2_1.csv`
    );
    const csv2_2 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q2_2.csv`
    );
    const csv3 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q3.csv`
    );
    const csv4 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q4.csv`
    );
    const csv5 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q5.csv`
    );
    const csv6 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q6.csv`
    );
    const csv7 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q7.csv`
    );
    const csv8 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q8.csv`
    );
    const csv9 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q9.csv`
    );
    const csv10 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q10.csv`
    );
    const csv11 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q11.csv`
    );
    const csv12 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q12.csv`
    );
    const csv13 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q13.csv`
    );
    const csv14 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q14.csv`
    );
    const csv15 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q15.csv`
    );
    const csv16 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q16.csv`
    );
    const csv17 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q17.csv`
    );
    const csv18 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q18.csv`
    );
    const csv19 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q19.csv`
    );
    const csv20 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q20.csv`
    );
    const csv21 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q21.csv`
    );
    const csv22 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q22.csv`
    );
    const csv23 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q23.csv`
    );
    const csv24 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q24.csv`
    );
    const csv25 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q25.csv`
    );
    const csv26 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q26.csv`
    );
    const csv27 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q27.csv`
    );
    const csv28 = await getCsvData(
      `/surveysNational/${language === "en" ? "/en/" : ""}mexico_q28.csv`
    );
    const dataObj8 = csv8.map((e) => {
      return {
        value: e["Porcentaje"] * 100,
        name: e["Afirmacion"],
      };
    });

    let data8 = dataObj8;

    const x_data9 = csv9.map((e) => e["Afirmacion"]);
    const y_data9 = csv9.map((e) => Number(e["Porcentaje"]) * 100);

    let data9 = [x_data9, y_data9];

    const y_data10 = Object.keys(csv10[0]).filter((e) => e !== "Afirmacion");
    const x_data10 = csv10.map((e) => e["Afirmacion"]);
    const series10 = y_data10.map((e, i) => {
      return x_data10.map((el) =>
        Number(csv10.find((e) => e["Afirmacion"] === el)[y_data10[i]])
      );
    });

    let data10 = [y_data10, x_data10, series10];

    let data11 = csv11.map((e) => {
      return {
        value: e["Porcentaje"],
        name: e["Afirmacion"],
      };
    });

    const x_data12 = csv12.map((e) => e["Afirmacion"]);
    const y_data12 = Object.keys(csv12[0]).filter((e) => e !== "Afirmacion");
    const series12 = y_data12.map((e, i) => {
      return x_data12.map((el) =>
        Number(csv12.find((e) => e["Afirmacion"] === el)[y_data12[i]])
      );
    });
    let data12 = [y_data12, x_data12, series12];

    const x_data13 = csv13.map((e) => e["Afirmacion"]);
    const y_data13 = Object.keys(csv13[0]).filter((e) => e !== "Afirmacion");
    const series13 = y_data13.map((e, i) => {
      return x_data13.map((el) =>
        Number(csv13.find((e) => e["Afirmacion"] === el)[y_data13[i]])
      );
    });
    let data13 = [y_data13, x_data13, series13];

    const x_data14 = csv14.map((e) => e["Afirmacion"]);
    const y_data14 = Object.keys(csv14[0]).filter((e) => e !== "Afirmacion");
    const series14 = y_data14.map((e, i) => {
      return x_data14.map((el) =>
        Number(csv14.find((e) => e["Afirmacion"] === el)[y_data14[i]])
      );
    });
    let data14 = [y_data14, x_data14, series14];

    const x_data15 = csv15.map((e) => e["Afirmacion"]);
    const y_data15 = Object.keys(csv15[0]).filter((e) => e !== "Afirmacion");
    const series15 = y_data15.map((e, i) => {
      return x_data15.map((el) =>
        Number(csv15.find((e) => e["Afirmacion"] === el)[y_data15[i]])
      );
    });
    let data15 = [y_data15, x_data15, series15];

    const x_data16 = csv16.map((e) => e["Afirmacion"]);
    const y_data16 = Object.keys(csv16[0]).filter((e) => e !== "Afirmacion");
    const series16 = y_data16.map((e, i) => {
      return x_data16.map((el) =>
        Number(csv16.find((e) => e["Afirmacion"] === el)[y_data16[i]])
      );
    });
    let data16 = [y_data16, x_data16, series16];

    let data17 = csv17.map((e) => {
      console.log("E", e);
      return {
        value: Number(e["Porcentaje"]),
        name: e["Afirmacion"],
      };
    });
    console.log("DATA17", data17);

    const x_data18 = csv18.map((e) => e["Afirmacion"]);
    const y_data18 = Object.keys(csv18[0]).filter((e) => e !== "Afirmacion");
    const series18 = y_data18.map((e, i) => {
      return x_data18.map((el) =>
        Number(csv18.find((e) => e["Afirmacion"] === el)[y_data18[i]])
      );
    });
    let data18 = [y_data18, x_data18, series18];

    const x_data1 = csv1.map((e) => e["Fecha"]);
    const y_data1 = Object.keys(csv1[0]).filter((e) => e !== "Fecha");
    let data1 = [
      x_data1,
      y_data1,
      [
        y_data1.map((e, i) => Number(csv1[0][y_data1[i]])),
        y_data1.map((e, i) => Number(csv1[1][y_data1[i]])),
        y_data1.map((e, i) => Number(csv1[2][y_data1[i]])),
      ],
    ];

    const x_data2 = csv2.map((e) => e["Fecha"]);
    const y_data2 = Object.keys(csv2[0]).filter((e) => e !== "Fecha");
    let data2 = [
      x_data2,
      y_data2,
      [
        y_data2.map((e, i) => Number(csv2[0][y_data2[i]])),
        y_data2.map((e, i) => Number(csv2[1][y_data2[i]])),
        y_data2.map((e, i) => Number(csv2[2][y_data2[i]])),
        y_data2.map((e, i) => Number(csv2[3][y_data2[i]])),
        y_data2.map((e, i) => Number(csv2[4][y_data2[i]])),
        y_data2.map((e, i) => Number(csv2[5][y_data2[i]])),
      ],
    ];

    const x_data2_2 = csv2_2.map((e) => e["Fecha"]);
    const y_data2_2 = Object.keys(csv2_2[0]).filter((e) => e !== "Fecha");
    let data2_2 = [
      x_data2_2,
      y_data2_2,
      [
        y_data2_2.map((e, i) => Number(csv2_2[0][y_data2_2[i]])),
        y_data2_2.map((e, i) => Number(csv2_2[1][y_data2_2[i]])),
        y_data2_2.map((e, i) => Number(csv2_2[2][y_data2_2[i]])),
        y_data2_2.map((e, i) => Number(csv2_2[3][y_data2_2[i]])),
        y_data2_2.map((e, i) => Number(csv2_2[4][y_data2_2[i]])),
        y_data2_2.map((e, i) => Number(csv2_2[5][y_data2_2[i]])),
      ],
    ];

    const x_data3 = csv3.map((e) => e["Fecha"]);
    const y_data3 = Object.keys(csv3[0]).filter((e) => e !== "Fecha");
    let data3 = [
      x_data3,
      y_data3,
      [
        y_data3.map((e, i) => Number(csv3[0][y_data3[i]])),
        y_data3.map((e, i) => Number(csv3[1][y_data3[i]])),
        y_data3.map((e, i) => Number(csv3[2][y_data3[i]])),
        y_data3.map((e, i) => Number(csv3[3][y_data3[i]])),
      ],
    ];

    const y_data4 = csv4.map((e) => e["Categoria"]);
    const x_data4 = Object.keys(csv4[0]).filter((e) => e !== "Categoria");
    let data4 = [
      x_data4,
      y_data4,
      [
        y_data4.map((e, i) => Number(csv4[i][x_data4[0]])),
        y_data4.map((e, i) => Number(csv4[i][x_data4[1]])),
        y_data4.map((e, i) => Number(csv4[i][x_data4[2]])),
        y_data4.map((e, i) => Number(csv4[i][x_data4[3]])),
      ],
    ];

    const x_data5 = csv5.map((e) => e["Fecha"]);
    const y_data5 = Object.keys(csv5[0]).filter((e) => e !== "Fecha");
    let data5 = [
      x_data5,
      y_data5,
      [
        y_data5.map((e, i) => Number(csv5[0][y_data5[i]])),
        y_data5.map((e, i) => Number(csv5[1][y_data5[i]])),
        y_data5.map((e, i) => Number(csv5[2][y_data5[i]])),
        y_data5.map((e, i) => Number(csv5[3][y_data5[i]])),
        y_data5.map((e, i) => Number(csv5[4][y_data5[i]])),
      ],
    ];

    /* const y_data6 = Object.keys(csv6[0]).filter((e) => e !== "Afirmacion");
    const x_data6 = csv6.map((e) => e["Afirmacion"]);
    const series6 = y_data6.map((e, i) => {
      return x_data6.map((el) =>
        Number(csv6.find((e) => e["Afirmacion"] === el)[y_data6[i]])
      );
    });
     */

    const x_data6 = Object.keys(csv6[0]).filter((e) => e !== "Afirmacion");
    const y_data6 = csv6.map((e) => e["Afirmacion"]);
    const yearData6 = x_data6.map((year) => {
      return csv6.map((e) => Number(e[year]));
    });
    let data6 = [x_data6, y_data6, yearData6];

    const x_data7 = Object.keys(csv7[0]).filter((e) => e !== "Afirmacion");
    const y_data7 = csv7.map((e) => e["Afirmacion"]);
    const yearData7 = x_data7.map((year) => {
      return csv7.map((e) => Number(e[year]));
    });
    let data7 = [x_data7, y_data7, yearData7];

    //q19

    const y_data19 = Object.keys(csv19[0]).filter((e) => e !== "Afirmacion");
    const x_data19 = csv19.map((e) => e["Afirmacion"]);
    const series19 = y_data19.map((e, i) => {
      return x_data19.map((el) =>
        Number(csv19.find((e) => e["Afirmacion"] === el)[y_data19[i]])
      );
    });
    const data19 = [y_data19, x_data19, series19];

    //q20

    const y_data20 = Object.keys(csv20[0]).filter((e) => e !== "Afirmacion");
    const x_data20 = csv20.map((e) => e["Afirmacion"]);
    const series20 = y_data20.map((e, i) => {
      return x_data20.map((el) =>
        Number(csv20.find((e) => e["Afirmacion"] === el)[y_data20[i]])
      );
    });
    const data20 = [y_data20, x_data20, series20];

    // Q21 NEW
    const x_data21 = csv21.map((e) => e["Afirmacion"]);
    const y_data21 = Object.keys(csv21[0]).filter((e) => e !== "Afirmacion");
    const series21 = y_data21.map((e, i) => {
      return x_data21.map((el) =>
        Number(csv21.find((e) => e["Afirmacion"] === el)[y_data21[i]])
      );
    });
    let data21 = [y_data21, x_data21, series21];

    // q22
    const y_data22 = csv22.map((e) => e["Categoria"]);
    const x_data22 = Object.keys(csv22[0]).filter((e) => e !== "Categoria");
    let data22 = [
      x_data22,
      y_data22,
      [
        y_data22.map((e, i) => Number(csv22[i][x_data22[0]])),
        y_data22.map((e, i) => Number(csv22[i][x_data22[1]])),
        y_data22.map((e, i) => Number(csv22[i][x_data22[2]])),
        y_data22.map((e, i) => Number(csv22[i][x_data22[3]])),
      ],
    ];

    // q23
    // q22
    const y_data23 = csv23.map((e) => e["Categoria"]);
    const x_data23 = Object.keys(csv23[0]).filter((e) => e !== "Categoria");
    let data23 = [
      x_data23,
      y_data23,
      [
        y_data23.map((e, i) => Number(csv23[i][x_data23[0]])),
        y_data23.map((e, i) => Number(csv23[i][x_data23[1]])),
        y_data23.map((e, i) => Number(csv23[i][x_data23[2]])),
        y_data23.map((e, i) => Number(csv23[i][x_data23[3]])),
        y_data23.map((e, i) => Number(csv23[i][x_data23[4]])),
        y_data23.map((e, i) => Number(csv23[i][x_data23[5]])),
      ],
    ];

    const x_data24 = csv24.map((e) => e["Afirmacion"]);
    const y_data24 = Object.keys(csv24[0]).filter((e) => e !== "Afirmacion");
    const series24 = y_data24.map((e, i) => {
      return x_data24.map((el) =>
        Number(csv24.find((e) => e["Afirmacion"] === el)[y_data24[i]])
      );
    });
    let data24 = [y_data24, x_data24, series24];

    // last one
    const x_data25 = csv25.map((e) => e["Afirmacion"]);
    const y_data25 = Object.keys(csv25[0]).filter((e) => e !== "Afirmacion");
    const series25 = y_data25.map((e, i) => {
      return x_data25.map((el) =>
        Number(csv25.find((e) => e["Afirmacion"] === el)[y_data25[i]])
      );
    });
    let data25 = [y_data25, x_data25, series25];

    // new ones
    //q30
    const y_data26 = Object.keys(csv26[0]).filter((e) => e !== "Afirmacion");
    const x_data26 = csv26.map((e) => e["Afirmacion"]);
    const series26 = y_data26.map((e, i) => {
      return x_data26.map((el) =>
        Number(csv26.find((e) => e["Afirmacion"] === el)[y_data26[i]])
      );
    });
    const data26 = [y_data26, x_data26, series26];

    //
    //
    const y_data27 = Object.keys(csv27[0]).filter((e) => e !== "Afirmacion");
    const x_data27 = csv27.map((e) => e["Afirmacion"]);
    const series27 = y_data27.map((e, i) => {
      return x_data27.map((el) =>
        Number(csv27.find((e) => e["Afirmacion"] === el)[y_data27[i]])
      );
    });
    const data27 = [y_data27, x_data27, series27];

    const y_data28 = Object.keys(csv28[0]).filter((e) => e !== "Afirmacion");
    const x_data28 = csv28.map((e) => e["Afirmacion"]);
    const series28 = y_data28.map((e, i) => {
      return x_data28.map((el) =>
        Number(csv28.find((e) => e["Afirmacion"] === el)[y_data28[i]])
      );
    });
    const data28 = [y_data28, x_data28, series28];

    let temp = [
      {
        id: "q1",
        question: TEXT["MEX"]["q1"]["question"][language],
        source: TEXT["MEX"]["q1"]["source"][language],
        description: TEXT["MEX"]["q1"]["description"][language],
        narrative: TEXT["MEX"]["q1"]["narrative"][language],
        data: data1,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q1"]["survey"][language],
        link: TEXT["MEX"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["MEX"]["q2"]["question"][language],
        source: TEXT["MEX"]["q2"]["source"][language],
        description: TEXT["MEX"]["q2"]["description"][language],
        narrative: TEXT["MEX"]["q2"]["narrative"][language],
        data: data2,
        data2: data2_2,
        graphType: "g_v_bar",
        options: [
          {
            code: "1",
            label: language === "en" ? "Foreigneirs" : "Extranjeros",
          },
          {
            code: "2",
            label: language === "en" ? "Immigrants" : "Inmigrantes",
          },
        ],
        hasOptions: true,
        survey: TEXT["MEX"]["q2"]["survey"][language],
        link: TEXT["MEX"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["MEX"]["q3"]["question"][language],
        source: TEXT["MEX"]["q3"]["source"][language],
        description: TEXT["MEX"]["q3"]["description"][language],
        narrative: TEXT["MEX"]["q3"]["narrative"][language],
        data: data3,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q3"]["survey"][language],
        link: TEXT["MEX"]["q3"]["link"],
      },
      {
        id: "q4",
        question: TEXT["MEX"]["q4"]["question"][language],
        source: TEXT["MEX"]["q4"]["source"][language],
        description: TEXT["MEX"]["q4"]["description"][language],
        narrative: TEXT["MEX"]["q4"]["narrative"][language],
        data: data4,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q4"]["survey"][language],
        link: TEXT["MEX"]["q4"]["link"],
      },
      {
        id: "q5",
        question: TEXT["MEX"]["q5"]["question"][language],
        source: TEXT["MEX"]["q5"]["source"][language],
        description: TEXT["MEX"]["q5"]["description"][language],
        narrative: TEXT["MEX"]["q5"]["narrative"][language],
        data: data5,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q5"]["survey"][language],
        link: TEXT["MEX"]["q5"]["link"],
      },
      {
        id: "q6",
        question: TEXT["MEX"]["q6"]["question"][language],
        source: TEXT["MEX"]["q6"]["source"][language],
        description: TEXT["MEX"]["q6"]["description"][language],
        narrative: TEXT["MEX"]["q6"]["narrative"][language],
        data: data6,
        graphType: "g_v_bar",
        isLarge: true,
        hasOptions: false,
        survey: TEXT["MEX"]["q6"]["survey"][language],
        link: TEXT["MEX"]["q6"]["link"],
        marginBottom: 70,
      },
      {
        id: "q7",
        question: TEXT["MEX"]["q7"]["question"][language],
        source: TEXT["MEX"]["q7"]["source"][language],
        description: TEXT["MEX"]["q7"]["description"][language],
        narrative: TEXT["MEX"]["q7"]["narrative"][language],
        data: data7,
        graphType: "g_v_bar",
        /* legendLabel:
          language === "es"
            ? "Muy de acuerdo + de acuerdo"
            : "Agree + strongly agree", */
        hasOptions: false,
        survey: TEXT["MEX"]["q7"]["survey"][language],
        link: TEXT["MEX"]["q7"]["link"],
      },
      {
        id: "q8",
        question: TEXT["MEX"]["q8"]["question"][language],
        source: TEXT["MEX"]["q8"]["source"][language],
        description: TEXT["MEX"]["q8"]["description"][language],
        data: data8,
        graphType: "pie",
        hasOptions: false,
        survey: TEXT["MEX"]["q8"]["survey"][language],
        link: TEXT["MEX"]["q8"]["link"],
      },
      {
        id: "q9",
        question: TEXT["MEX"]["q9"]["question"][language],
        source: TEXT["MEX"]["q9"]["source"][language],
        description: TEXT["MEX"]["q9"]["description"][language],
        data: data9,
        graphType: "bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q9"]["survey"][language],
        link: TEXT["MEX"]["q9"]["link"],
        marginBottom: 80,
      },
      {
        id: "q10",
        question: TEXT["MEX"]["q10"]["question"][language],
        source: TEXT["MEX"]["q10"]["source"][language],
        description: TEXT["MEX"]["q10"]["description"][language],
        data: data10,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q10"]["survey"][language],
        link: TEXT["MEX"]["q10"]["link"],
      },
      {
        id: "q11",
        question: TEXT["MEX"]["q11"]["question"][language],
        source: TEXT["MEX"]["q11"]["source"][language],
        description: TEXT["MEX"]["q11"]["description"][language],
        data: data11,
        graphType: "pie",
        hasOptions: false,
        survey: TEXT["MEX"]["q11"]["survey"][language],
        link: TEXT["MEX"]["q11"]["link"],
      },
      {
        id: "q12",
        question: TEXT["MEX"]["q12"]["question"][language],
        source: TEXT["MEX"]["q12"]["source"][language],
        description: TEXT["MEX"]["q12"]["description"][language],
        data: data12,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q12"]["survey"][language],
        link: TEXT["MEX"]["q12"]["link"],
      },
      {
        id: "q13",
        question: TEXT["MEX"]["q13"]["question"][language],
        source: TEXT["MEX"]["q13"]["source"][language],
        description: TEXT["MEX"]["q13"]["description"][language],
        data: data13,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q13"]["survey"][language],
        link: TEXT["MEX"]["q13"]["link"],
      },
      {
        id: "q14",
        question: TEXT["MEX"]["q14"]["question"][language],
        source: TEXT["MEX"]["q14"]["source"][language],
        description: TEXT["MEX"]["q14"]["description"][language],
        data: data14,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q14"]["survey"][language],
        link: TEXT["MEX"]["q14"]["link"],
        marginBottom: 100,
      },
      {
        id: "q15",
        question: TEXT["MEX"]["q15"]["question"][language],
        source: TEXT["MEX"]["q15"]["source"][language],
        description: TEXT["MEX"]["q15"]["description"][language],
        data: data15,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q15"]["survey"][language],
        link: TEXT["MEX"]["q15"]["link"],
      },
      {
        id: "q16",
        question: TEXT["MEX"]["q16"]["question"][language],
        source: TEXT["MEX"]["q16"]["source"][language],
        description: TEXT["MEX"]["q16"]["description"][language],
        data: data16,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q16"]["survey"][language],
        link: TEXT["MEX"]["q16"]["link"],
      },
      {
        id: "q17",
        question: TEXT["MEX"]["q17"]["question"][language],
        source: TEXT["MEX"]["q17"]["source"][language],
        description: TEXT["MEX"]["q17"]["description"][language],
        data: data17,
        graphType: "pie",
        hasOptions: false,
        survey: TEXT["MEX"]["q17"]["survey"][language],
        link: TEXT["MEX"]["q17"]["link"],
      },
      {
        id: "q18",
        question: TEXT["MEX"]["q18"]["question"][language],
        source: TEXT["MEX"]["q18"]["source"][language],
        description: TEXT["MEX"]["q18"]["description"][language],
        data: data18,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q18"]["survey"][language],
        link: TEXT["MEX"]["q18"]["link"],
      },
      {
        id: "q19",
        question: TEXT["MEX"]["q19"]["question"][language],
        source: TEXT["MEX"]["q19"]["source"][language],
        description: TEXT["MEX"]["q19"]["description"][language],
        data: data19,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q19"]["survey"][language],
        link: TEXT["MEX"]["q19"]["link"],
      },
      {
        id: "q20",
        question: TEXT["MEX"]["q20"]["question"][language],
        source: TEXT["MEX"]["q20"]["source"][language],
        description: TEXT["MEX"]["q20"]["description"][language],
        data: data20,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q20"]["survey"][language],
        link: TEXT["MEX"]["q20"]["link"],
      },
      {
        id: "q21",
        question: TEXT["MEX"]["q21"]["question"][language],
        source: TEXT["MEX"]["q21"]["source"][language],
        description: TEXT["MEX"]["q21"]["description"][language],
        data: data21,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q21"]["survey"][language],
        link: TEXT["MEX"]["q21"]["link"],
      },
      {
        id: "q22",
        question: TEXT["MEX"]["q22"]["question"][language],
        source: TEXT["MEX"]["q22"]["source"][language],
        description: TEXT["MEX"]["q22"]["description"][language],
        data: data22,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q22"]["survey"][language],
        link: TEXT["MEX"]["q22"]["link"],
        marginBottom: 200,
      },
      {
        id: "q23",
        question: TEXT["MEX"]["q23"]["question"][language],
        source: TEXT["MEX"]["q23"]["source"][language],
        description: TEXT["MEX"]["q23"]["description"][language],
        data: data23,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q23"]["survey"][language],
        link: TEXT["MEX"]["q23"]["link"],
        marginBottom: 100,
      },
      {
        id: "q24",
        question: TEXT["MEX"]["q24"]["question"][language],
        source: TEXT["MEX"]["q24"]["source"][language],
        description: TEXT["MEX"]["q24"]["description"][language],
        data: data24,
        graphType: "g_v_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q24"]["survey"][language],
        link: TEXT["MEX"]["q24"]["link"],
        marginBottom: 100,
      },
      {
        id: "q25",
        question: TEXT["MEX"]["q25"]["question"][language],
        source: TEXT["MEX"]["q25"]["source"][language],
        description: TEXT["MEX"]["q25"]["description"][language],
        data: data25,
        graphType: "s_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q25"]["survey"][language],
        link: TEXT["MEX"]["q25"]["link"],
      },
      {
        id: "q26",
        question: TEXT["MEX"]["q26"]["question"][language],
        source: TEXT["MEX"]["q26"]["source"][language],
        description: TEXT["MEX"]["q26"]["description"][language],
        data: data26,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q26"]["survey"][language],
        link: TEXT["MEX"]["q26"]["link"],
      },
      {
        id: "q27",
        question: TEXT["MEX"]["q27"]["question"][language],
        source: TEXT["MEX"]["q27"]["source"][language],
        description: TEXT["MEX"]["q27"]["description"][language],
        data: data27,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q27"]["survey"][language],
        link: TEXT["MEX"]["q27"]["link"],
      },
      {
        id: "q28",
        question: TEXT["MEX"]["q28"]["question"][language],
        source: TEXT["MEX"]["q28"]["source"][language],
        description: TEXT["MEX"]["q28"]["description"][language],
        data: data28,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["MEX"]["q28"]["survey"][language],
        link: TEXT["MEX"]["q28"]["link"],
      },
    ];
    let tempQ = [];
    temp.forEach((e) => {
      if (e.survey === survey) tempQ.push({ code: e.id, label: e.question });
    });
    setData(temp.filter((el) => el.survey === survey));
    setQuestions(tempQ);
  };

  return (
    <div>
      <SurveyNational data={data} questions={questions} title={survey} />
    </div>
  );
}
